<template>
  <div class="stock-linked-sales-orders stock-linked-section">
    <v-subheader class="stock-linked-section__title px-0 font-weight-bold">
      {{ title }}
    </v-subheader>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="-1"
      class="stock-linked-sales-orders__table stock-linked-table"
    >
      <template v-slot:item.code="{ item }">
        <router-link :to="{ name: 'stock-sales-orders-view', params: { id: item.id } }">
          {{ item.code }}
        </router-link>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip small :color="statusColor(item.status)" dark>
          {{ statusLabel(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.customer="{ item }">
        {{ companyLabel(item.customer_company) }}
      </template>
      <template v-slot:item.warehouse="{ item }">
        {{ warehouseLabelFromOrder(item.source_warehouse) }}
      </template>
      <template v-slot:item.order_date="{ item }">
        {{ item.order_date || "-" }}
      </template>
      <template v-slot:item.requested_delivery_date="{ item }">
        {{ item.requested_delivery_date || "-" }}
      </template>
      <template v-slot:item.items_count="{ item }">
        {{ lineCount(item) }}
      </template>
      <template v-slot:item.total_gross="{ item }">
        {{ formatOrderMoney(item.total_gross, item.currency_code) }}
      </template>
    </v-data-table>
    <v-alert v-if="!items.length" type="info" dense text class="mt-2">
      {{ emptyMessage }}
    </v-alert>
  </div>
</template>

<script>
import stockLinkedOrderRowDisplayMixin from "@/views/partials/stock/stockLinkedOrderRowDisplay.mixin";
import { buildLinkedDocumentHeaders } from "@/views/partials/stock/stockLinkedTableHeaders";

export default {
  name: "StockLinkedSalesOrdersTable",
  mixins: [stockLinkedOrderRowDisplayMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    emptyMessage: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        ...buildLinkedDocumentHeaders(this.$t.bind(this), {
          codeLabelKey: "STOCK.SALES_ORDERS.DOCUMENT_CODE",
          counterpartyLabelKey: "STOCK.SALES_ORDERS.CUSTOMER",
          counterpartyValue: "customer",
          warehouseLabelKey: "STOCK.SALES_ORDERS.SOURCE_WAREHOUSE",
          dateLabelKey: "STOCK.SALES_ORDERS.ORDER_DATE",
          dateValue: "order_date",
        }),
        {
          text: this.$t("STOCK.SALES_ORDERS.REQUESTED_DELIVERY"),
          value: "requested_delivery_date",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    statusColor(status) {
      const map = {
        draft: "grey",
        confirmed: "primary",
        partially_delivered: "orange darken-2",
        delivered: "success",
        invoiced: "teal",
        closed: "grey darken-1",
        cancelled: "error",
      };
      return map[status] || "grey";
    },
    statusLabel(status) {
      const key = `STOCK.STATUSES.SO.${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/views/partials/stock/stockLinkedTable.scss";

.stock-linked-sales-orders__table a {
  text-decoration: none;
  font-weight: 500;
}
.stock-linked-sales-orders__table a:hover {
  text-decoration: underline;
}
</style>
